import Tooltip from "./Tooltip";
import { TooltipProps, TooltipStyles } from "./types";

export default Tooltip;

export { Tooltip };
export type { TooltipProps, TooltipStyles };
